// i18next.config.js
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import Backend from 'i18next-http-backend'

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    fallbackLng: 'en',
    debug: false,
    ns: ['inboundTicket'], // Add your namespaces here
    defaultNS: 'inboundTicket',
    interpolation: {
      escapeValue: false, // React already safes from xss
    },
  })

export default i18n
